module.exports = __webpack_public_path__ + "static/media/banner-warning.ffae5f7c.svg";